const TRACKING_API_PATH = "/api/shiprocket/track";

export async function trackShiprocketOrder({ awb, shipmentId }) {
  try {
    const res = await fetch(TRACKING_API_PATH, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify({
        awb: String(awb || "").trim(),
        shipmentId: String(shipmentId || "").trim(),
      }),
    });
    const data = await res.json().catch(() => null);
    if (!res.ok || data?.ok === false) {
      return {
        ok: false,
        message: data?.message || `Tracking request failed (${res.status})`,
        data,
      };
    }
    return { ok: true, data };
  } catch (err) {
    return {
      ok: false,
      message: err?.message || "Network error while loading tracking.",
    };
  }
}
